<template>
  <el-row class="app-header" type="flex" justify="center" align="middle">
    <el-col :span="2" :offset="1">
      <el-image :src="contact.web_site_logo" fit="fill" />
      <span class="logo-text">{{ contact.web_site_logo_text }}</span>
    </el-col>

    <el-col :span="10">
      <el-menu
        class="el-menu-demo"
        :default-active="activeIndex"
        mode="horizontal"
        @select="handleSelect"
        :router="true"
        background-color="#ffffff"
        text-color="#333"
        active-text-color="#2c9dcf"
      >
        <el-menu-item
          v-for="(item, index) of topNav"
          :key="`${item.id}-${item.url}`"
          :index="`${item.url}?classify_id=${item.id}`"
        >
          {{ item.name }}
        </el-menu-item>
      </el-menu>
    </el-col>
    <el-col :span="2">
      <p class="slogan">{{ contact.web_site_slogan }}</p>
    </el-col>
    <el-col :span="2" style="display: flex; align-items: center;">
      <div class="recruitment" @click="handleRecruitment">商家入驻</div>
      <el-link class="understand-name" :href="`https://erp.runyuyunyin.com`" target="_blank" :underline="false">登录</el-link>
    </el-col>
    <el-dialog title="商家入驻" :modal="false" :visible.sync="open" width="30%" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="96px" >
        <el-form-item label="公司名称" prop="company">
          <el-input v-model="form.company" placeholder="请输入公司名称" clearable />
        </el-form-item>

        <el-form-item label="所属行业" prop="profession">
          <el-input v-model="form.profession" placeholder="请输入所属行业" clearable />
        </el-form-item>

        <el-form-item label="企业规模" prop="scale">
          <el-input v-model="form.scale" placeholder="请输入企业规模" clearable />
        </el-form-item>

        <el-form-item label="联系人" prop="contract">
          <el-input v-model="form.contract" placeholder="请输入联系人" clearable />
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入电话号码" clearable maxlength="11" />
        </el-form-item>

        <el-form-item label="验证码" prop="code" class="code">
          <el-input v-model.trim="form.code" style="width: 73%" prefix-icon="Lock" placeholder="请输入验证码" :disabled="form.phone == null" />
          <el-button class="login-code" style="width: 27%;height: 40px;" @click="showCodeDialog" :disabled="form.phone == null || timer > 0">
            {{ timer > 0 ? `${timer}s后重新获取` : '获取验证码' }}
          </el-button>
        </el-form-item>

        <!-- 验证码弹框 -->
        <el-dialog title="请输入验证码" :visible.sync="codeDialogVisible" width="360px" append-to-body :close-on-click-modal="false">
          <div style="text-align: center;margin-bottom: 20px;">
            <el-image :src="codeUrl" style="width: 150px;height: 40px;cursor: pointer;" @click="handleCode" />
          </div>
          <el-input v-model="dialogParams.code" placeholder="请输入验证码" clearable />
          <span slot="footer">
            <el-button @click="codeDialogVisible = false; dialogParams = {}">取 消</el-button>
            <el-button type="primary" @click="confirmCode">确 定</el-button>
          </span>
        </el-dialog>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱" clearable />
        </el-form-item>

        <el-form-item label="所在地区" prop="region">
          <el-input v-model="form.region" placeholder="请输入所在地区" clearable />
        </el-form-item>

        <el-form-item label="详细地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入详细地址" clearable />
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="open = false; form = {}; timer = 0;">关闭</el-button>
        <el-button type="primary" @click="submit">提交审核</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import { merchantCheckIn, getCode, getSendSmsCode } from '@/api/index'
export default {
  computed: {
    topNav() {
      // return this.$store.state.getHomeData.topNav
      const navList = this.$store.state.getHomeData.topNav
      const idMap = {
        '/': 0,
        '/product': 11,
        '/case': 2,
        '/industry': 3,
        '/new': 4,
        '/about': 6,
        '/contact': 7
      }
      return navList.map(item => ({
        ...item,
        id: idMap[item.url] || item.id || 0
      }))
    },
    contact() {
      return this.$store.state.getHomeData.contact
    }
  },
  data() {
    return {
      activeIndex: '', // 默认选中的菜单项索引
      open: false, // 是否显示弹窗
      form: {}, // 表单数据
      rules:{
        company: { required: true, message: '请输入公司名称', trigger: 'blur' },
        profession:{ required: true, message: '请选择所属行业', trigger: 'change' },
        scale:{ required: true, message: '请选择公司规模', trigger: 'change' },
        contract:{ required: true, message: '请输入联系人', trigger: 'blur' },
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {pattern: /^[1,0][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        code:{ required: true, message: '请输入验证码', trigger: 'blur' },
        email:{ required: true, message: '请输入邮箱', trigger: 'blur' },
        region:{ required: true, message: '请输入所在地区', trigger: 'blur' },
        address:{ required: true, message: '请输入详细地址', trigger: 'blur' },
      },
      codeUrl: '', // 验证码图片地址
      codeDialogVisible: false, // 验证码弹框显示状态
      timer: 0,
      interval: null,
      dialogParams: {
        phone: null,
        code: null,
        uuid: null
      }
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler(to) {
        this.activeIndex = to.fullPath;
      }
    }
  },
  created() {
    // this.handleCode();
    // 确保在获取导航数据后设置默认选中项
    this.$nextTick(() => {
      if (this.topNav && this.topNav.length > 0) {
        const firstNav = this.topNav[0];
        this.activeIndex = `${firstNav.url}?classify_id=${firstNav.id}`;
      }
    });
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key
      this.$router.replace({
        path: key,
        replace: true
      }).catch(() => {})
    },
    // 商家入驻
    handleRecruitment() {
      this.open = true;
    },
    // 获取验证码
    handleCode() {
      getCode().then(res => {
        if(res.code == 200) {
          this.codeUrl = res.img;
          this.dialogParams.uuid = res.uuid;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 显示验证码弹框
    showCodeDialog() {
      this.codeDialogVisible = true
      this.handleCode()
      this.dialogParams.phone = this.form.phone
    },

    // 确认验证码
    confirmCode() {
      if (!this.dialogParams.code) {
        this.$message.warning('请输入验证码')
        return
      }
      this.codeDialogVisible = false
      this.getSmsCode()
      this.dialogParams = {}
    },

    // 获取短信验证码
    getSmsCode() {
      getSendSmsCode(this.dialogParams).then(res => {
        if(res.code == 200) {
          this.$message.success('验证码已发送')
          this.startTimer()
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    startTimer() {
      if (this.timer > 0) return
      // 先开始倒计时
      this.timer = 60
      this.interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        } else {
          clearInterval(this.interval)
        }
      }, 1000)
    },

    // 提交审核
    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          merchantCheckIn(this.form).then(res => {
            if(res.code === 200)  {
              this.$message({
                type: 'success',
                message: '提交成功'
              });
              this.open = false;
              this.$refs['form'].resetFields();
            } else {
              this.$message({
                type: 'error',
                message: '提交失败'
              });
            }
          });
        }
      });
    }
  }
}
</script>

<style lang="scss">
.app-header{
  height:60px;
  font-weight: 600;
  text-align: center;
  overflow: hidden;
  background-color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 999;

  .el-image{
    width:50px;
    vertical-align: middle;
    padding-right: 10px;
  }
  .logo-text{
    font-size: 14px;
    font-weight: 500!important;
  }
  .slogan {
    font-size: 14px;
    color: #333;
    font-weight: 400 ;
  }
  .recruitment {
    font-size: 14px;
    font-weight: 400;
    color: #1890FF;
    cursor: pointer;
    padding-right: 20px;
  }
}
</style>
